export const DAYS_TO_BE_CONSIDERED_NEW_GAME = 7;
